import { render, staticRenderFns } from "./AutoCompleteComponent.vue?vue&type=template&id=37ef5e08&"
import script from "./AutoCompleteComponent.vue?vue&type=script&lang=ts&"
export * from "./AutoCompleteComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports